"use client"

import React from "react"
import { useBreadcrumb } from "./BreadcrumbProvider"
import "../Components/Css/Breadcrumb.css"
import GreyArrow from "../assets/greyLeftAr.png";

/**
 * Universal Breadcrumb Component
 * @param {Object} props
 * @param {Array} props.items - Optional custom breadcrumb items to override the automatic ones
 * @param {string} props.separator - Custom separator (optional)
 * @param {boolean} props.showHome - Whether to show the home/dashboard link (default: true)
 */
function Breadcrumb({ items, separator = ">", showHome = true }) {
  // Get breadcrumbs from context
  const { breadcrumbs: contextBreadcrumbs, navigateTo, setCustomBreadcrumbs } = useBreadcrumb()

  // Use provided items or context breadcrumbs
  const breadcrumbs = items || contextBreadcrumbs

  // Set custom breadcrumbs if provided
  React.useEffect(() => {
    if (items) {
      setCustomBreadcrumbs(items)
    }
  }, [items, setCustomBreadcrumbs])

  // Filter out home if not needed
  const filteredBreadcrumbs = showHome ? breadcrumbs : breadcrumbs.filter((_, index) => index > 0)

  // Don't render if there's only one or no breadcrumb
  if (filteredBreadcrumbs.length <= 1) return null

  return (
    <div className="breadcrumb-container" aria-label="breadcrumb">
      <ol className="breadcrumb">
        {filteredBreadcrumbs.map((item, index) => {
          const isLast = index === filteredBreadcrumbs.length - 1

          return (
            <React.Fragment key={index}>
              <li className={`breadcrumb-item ${isLast ? "active" : ""}`}>
                {isLast ? (
                  <span>{item.label}</span>
                ) : (
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault()
                      navigateTo(item.path, index)
                    }}
                  >
                    {item.label}
                  </a>
                )}
              </li>
              {!isLast && (
                <li className="breadcrumb-separator" aria-hidden="true">
                  <img src={GreyArrow} alt="Rapid Car Leasing" />
                </li>
              )}
            </React.Fragment>
          )
        })}
      </ol>
    </div>
  )
}

export default Breadcrumb
